export default __webpack_public_path__ + "static/media/favicon.c2388b2b.ico";